import React from "react";
import { graphql, Link, StaticQuery } from "gatsby";
import LinkedinLogo from "../vectors/linkedin";
import PhoneIcon from "../vectors/phone-icon";
import Logo from "../vectors/escriptLogo";

const PageFooter = (props) => {
  const doc = props.data.prismic.allFooters.edges.slice(0, 1).pop();
  const data = props.data.prismic.allFooters.edges[0].node;
  const currentYear = new Date().getFullYear();

  if (!doc || !data) return null;

  return (
    <div className="page-footer">
      <div className="page-footer__inner">
        <div className="page-footer__top">
          <div className="page-footer__logo">
            <Link to="/">
              <Logo fill="#FFFFFF" />
            </Link>
          </div>

          <ul className="page-footer__nav">
            <li><a href="/360-gateway">360 Gateway</a></li>
            <li><a href="/about-us">About Us</a></li>
            <li><a href="/join-us">Join Us</a></li>

            <ul className="page-footer__social">
              <li>
                <Link to={data.linkedin_url.url || "/"}>
                  <LinkedinLogo className="logo" />
                </Link>
              </li>
            </ul>
          </ul>

          <ul className="page-footer__nav">
            <li>
              <div className="page-footer__help">
                <div className="page-footer__help-header">
                  {data.here_to_help_heading}
                </div>

                <div className="page-footer__help-content">
                  701 Koehler Avenue<br />
                  Ronkonkoma, NY 11779
                </div>
              </div>
            </li>

            <li>
              <div className="page-footer__phone">
                <div className="page-footer__phone-section">
                  <PhoneIcon className="phone-icon" />

                  <a href={"tel:" + data.phone_number} className="page-footer__phone-number">
                    {data.phone_number}
                  </a>
                </div>
                <br />
                <div className="page-footer__phone-section">
                  <svg className="phone-icon" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                  <g><g><g><path fill="#fff" d="m387.312 58.573h-145.92c-4.234 0-7.665 3.432-7.665 7.665s3.431 7.665 7.665 7.665h145.92c4.234 0 7.665-3.432 7.665-7.665s-3.431-7.665-7.665-7.665z"/><path fill="#fff" d="m387.312 94.34h-145.92c-4.234 0-7.665 3.432-7.665 7.665s3.431 7.665 7.665 7.665h145.92c4.234 0 7.665-3.432 7.665-7.665 0-4.234-3.431-7.665-7.665-7.665z"/><path fill="#fff" d="m477.865 138.142h-1.018v-18.355c0-12.219-9.941-22.16-22.16-22.16h-7.286v-13.472c0-4.233-3.431-7.665-7.665-7.665s-7.665 3.432-7.665 7.665v53.987h-235.437v-116.725c0-3.357 2.731-6.087 6.087-6.087h223.263c3.357 0 6.088 2.731 6.088 6.087v26.905c0 4.233 3.431 7.665 7.665 7.665s7.665-3.432 7.665-7.665v-26.905c-.001-11.81-9.609-21.417-21.418-21.417h-223.263c-11.809 0-21.416 9.607-21.416 21.417v76.211h-7.287c-8.753 0-16.335 5.102-19.934 12.488-6.929-6.191-16.062-9.963-26.063-9.963h-51.951c-21.201 0-38.51 16.937-39.136 37.99h-2.799c-18.445 0-33.451 15.006-33.451 33.451v268.967c0 18.445 15.006 33.451 33.451 33.451h2.799c.626 21.051 17.935 37.988 39.136 37.988h51.95c21.202 0 38.511-16.937 39.137-37.99h310.709c18.445 0 33.451-15.006 33.451-33.451v-268.967c-.001-18.444-15.007-33.45-33.452-33.45zm-30.464-25.185h7.286c3.766 0 6.83 3.064 6.83 6.83v18.355h-14.117v-25.185zm-273.384 0h7.287v25.185h-14.118v-18.355c.001-3.767 3.065-6.83 6.831-6.83zm-158.004 327.602v-268.967c0-9.992 8.13-18.121 18.122-18.121h2.769v14.765c0 35.81 4.911 58.652 7.431 80.084v115.26c-9.671 47.91-6.965 81.911-7.431 95.1h-2.769c-9.992.001-18.122-8.129-18.122-18.121zm135.844 32.275c0 13.144-10.694 23.837-23.837 23.837h-51.95c-13.144 0-23.836-10.693-23.836-23.837.712-24.236-2.767-57.726 7.276-106.951.103-.504.155-1.018.155-1.532v-116.55c0-.345-.023-.691-.07-1.033-2.506-21.219-7.361-43.883-7.361-78.532v-28.918c0-13.144 10.693-23.837 23.836-23.837h51.95c13.144 0 23.837 10.693 23.837 23.837v6.489 22.43c0 34.514-4.76 56.502-7.361 78.532-.047.342-.07.688-.07 1.033v116.548c0 .514.052 1.028.155 1.532 10.035 49.194 6.558 82.51 7.276 106.952zm344.13-32.275c0 9.993-8.13 18.122-18.122 18.122h-310.678c-.444-12.542 2.249-47.134-7.431-95.1v-115.261c2.533-21.543 7.431-44.157 7.431-80.084v-14.765h310.679c9.992 0 18.122 8.129 18.122 18.121v268.967z"/><path fill="#fff" d="m417.381 187.72h-206.057c-9.83 0-17.828 7.997-17.828 17.828v48.08c0 9.83 7.998 17.828 17.828 17.828h35.831c4.234 0 7.665-3.432 7.665-7.665s-3.431-7.665-7.665-7.665h-35.831c-1.378 0-2.499-1.121-2.499-2.498v-48.08c0-1.378 1.121-2.498 2.499-2.498h206.057c1.377 0 2.498 1.121 2.498 2.498v48.08c0 1.378-1.121 2.498-2.498 2.498h-134.392c-4.234 0-7.665 3.432-7.665 7.665s3.431 7.665 7.665 7.665h134.392c9.83 0 17.827-7.997 17.827-17.828v-48.08c.001-9.83-7.996-17.828-17.827-17.828z"/><path fill="#fff" d="m228.573 296.387h-20.172c-8.219 0-14.905 6.686-14.905 14.905v19.411c0 8.219 6.687 14.905 14.905 14.905h20.172c8.219 0 14.904-6.687 14.904-14.905v-19.411c0-8.219-6.686-14.905-14.904-14.905zm-.425 33.891h-19.322v-18.562h19.322z"/><path fill="#fff" d="m292.483 296.387h-20.172c-8.219 0-14.905 6.686-14.905 14.905v19.411c0 8.219 6.687 14.905 14.905 14.905h20.172c8.219 0 14.905-6.687 14.905-14.905v-19.411c0-8.219-6.686-14.905-14.905-14.905zm-.424 33.891h-19.323v-18.562h19.323z"/><path fill="#fff" d="m356.393 296.387h-20.172c-8.219 0-14.905 6.686-14.905 14.905v19.411c0 8.219 6.687 14.905 14.905 14.905h20.172c8.219 0 14.905-6.687 14.905-14.905v-19.411c0-8.219-6.686-14.905-14.905-14.905zm-.424 33.891h-19.323v-18.562h19.323z"/><path fill="#fff" d="m420.303 296.387h-20.172c-8.219 0-14.904 6.686-14.904 14.905v19.411c0 8.219 6.686 14.905 14.904 14.905h20.172c8.219 0 14.905-6.687 14.905-14.905v-19.411c.001-8.219-6.686-14.905-14.905-14.905zm-.424 33.891h-19.322v-18.562h19.322z"/><path fill="#fff" d="m228.573 369.27h-20.172c-8.219 0-14.905 6.686-14.905 14.905v19.411c0 8.219 6.687 14.905 14.905 14.905h20.172c8.219 0 14.904-6.686 14.904-14.905v-19.411c0-8.218-6.686-14.905-14.904-14.905zm-.425 33.892h-19.322v-18.562h19.322z"/><path fill="#fff" d="m292.483 369.27h-20.172c-8.219 0-14.905 6.686-14.905 14.905v19.411c0 8.219 6.687 14.905 14.905 14.905h20.172c8.219 0 14.905-6.686 14.905-14.905v-19.411c0-8.218-6.686-14.905-14.905-14.905zm-.424 33.892h-19.323v-18.562h19.323z"/><path fill="#fff" d="m356.393 369.27h-20.172c-8.219 0-14.905 6.686-14.905 14.905v19.411c0 8.219 6.687 14.905 14.905 14.905h20.172c8.219 0 14.905-6.686 14.905-14.905v-19.411c0-8.218-6.686-14.905-14.905-14.905zm-.424 33.892h-19.323v-18.562h19.323z"/><path fill="#fff" d="m420.303 369.27h-20.172c-8.219 0-14.904 6.686-14.904 14.905v19.411c0 8.219 6.686 14.905 14.904 14.905h20.172c8.219 0 14.905-6.686 14.905-14.905v-19.411c.001-8.218-6.686-14.905-14.905-14.905zm-.424 33.892h-19.322v-18.562h19.322z"/></g></g></g></svg>
                  <a href="tel:516-492-3356" className="page-footer__phone-number">
                  516-492-3356
                  </a>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <div className="page-footer__bottom">
          <div className="page-footer__policies">
            <span className="page-footer__copyright">
              ©{currentYear} eScript360
            </span>

            <ul>
              <li><a href="/privacy-policy">Privacy Policy</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default (props) => (
  <StaticQuery
    query={graphql`
      {
        site {
          siteMetadata {
            getStartedUrl
            appStoreUrl
          }
        }
        prismic {
          allFooters {
            edges {
              node {
                phone_number
                linkedin_url {
                  _linkType
                }
                here_to_help_heading
                navigation_links {
                  link
                  title
                }
                policy_links {
                  title
                  link
                }
              }
            }
            pageInfo {
              startCursor
              endCursor
            }
          }
        }
      }
    `}
    render={(data) => <PageFooter data={data} {...props} />}
  />
);
